export default __webpack_public_path__ + "static/media/Baby5.e2eeabc8.gif";